import React, { useContext, useEffect, useState } from "react";
import { Button, Modal, Row } from "reactstrap";
import { MainContext } from "context/mainContext";

import "./styles.css";

const EvaToggleSwitch = ({ ...props }) => {
  const { selectedClientID } = useContext(MainContext);
  const [isToggle, setIsToggle] = useState(false);
  const [modal, setModal] = useState(false);
  const [disclaimModal, setDisclaimModal] = useState(false);

  const openDisclaimerModalHandler = () => setDisclaimModal(true);
  const closeDisclaimerModalHandler = () => setDisclaimModal(false);

  const onChangeSettings = () => setModal(true);

  const closeModalHandler = () => setModal(false);

  const submitEvaModalHandler = async () => {
    try {
      const details = await fetch("/api/eva/toggle", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          businessId: props.businessId,
          clientId: props.clientId,
          isAdvisorOnly: isToggle,
        }),
      });

      const data = await details.json();

      if (data.success) {
        setIsToggle(!isToggle);
        setModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setIsToggle(props.isVisibleToClient);
  }, [props.isVisibleToClient, selectedClientID]);


  return (
    <>
      <Row className="text-right d-flex align-items-center justify-content-left" style={{ marginTop: '10px' }}>
        <label className="switch-container" title="Toggle to show/hide from client users  ">
          <input type="checkbox" checked={isToggle} onChange={onChangeSettings} />
          <span className="slider" />
          {isToggle ? (
            <span className="toggle-off">ON</span>
          ) : (
            <span className="toggle-on">OFF</span>
          )}
        </label>
        &nbsp;&nbsp;
        <a href="javascript:void" onClick={openDisclaimerModalHandler}>
          <i className="fa fa-exclamation-triangle" aria-hidden="true" style={{ color: 'orange' }} title="Disclaimer"></i>
        </a>
      </Row>
      <Modal
        className="modal-dialog-top"
        isOpen={modal}
        size="lg"
        backdrop="static"
      >
        <div style={{ padding: "20px 20px 5px 20px" }}>
          <h1 style={{ marginBottom: "0px", fontSize: "30px" }}>
            {isToggle === false ?
              "Enable EVA to all client users"
              : "Disable EVA to all client users"
            }
          </h1>
          <p
            style={{
              textAlign: "left",
              margin: "0px",
              marginBottom: "20px",
              fontSize: "18px",
            }}
          >
            Currently, EVA is only visible to admins
          </p>
          <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
        </div>
        <div className="modal-footer" style={{ padding: "0px 20px 10px 20px" }}>
          <Button
            style={{
              backgroundColor: "#32325d",
              border: "1px solid #32325d",
              color: "#fff",
            }}
            onClick={submitEvaModalHandler}
          >
            Confirm
          </Button>
          <Button
            style={{
              backgroundColor: "#32325d",
              border: "1px solid #32325d",
              color: "#fff",
            }}
            data-dismiss="modal"
            onClick={closeModalHandler}
          >
            Cancel
          </Button>
        </div>
      </Modal>
      <Modal
        className="modal-dialog-top"
        isOpen={disclaimModal}
        size="lg"
        backdrop="static"
      >
        <div style={{ padding: "20px 20px 5px 20px" }}>
          <h1 style={{ marginBottom: "0px", fontSize: "30px" }}>
            Disclaimer
          </h1>
          <p
            style={{
              textAlign: "left",
              margin: "0px",
              marginBottom: "20px",
              fontSize: "18px",
            }}
          >
            The output generated by our Artificial Intelligence (AI) system, (known as EVA), including any advice, is based on data, algorithms and your inputs. It is not generated or checked by human experts, and as a result may contain false, misleading or incorrect responses. Whilst we strive to provide accurate and helpful advice, it may not always be applicable or correct.
          </p>
          <p
            style={{
              textAlign: "left",
              margin: "0px",
              marginBottom: "20px",
              fontSize: "18px",
            }}
          >
            The advice provided by EVA is intended as a guide only and should not be relied upon without consulting an appropriate professional.
          </p>
          <p
            style={{
              textAlign: "left",
              margin: "0px",
              marginBottom: "20px",
              fontSize: "18px",
            }}
          >
            By using EVA you agree that, to the extent permitted by law, you will not hold One Place Business Platform Pty Ltd ACN 612 278 180, its related bodies corporate or any of their directors, officers, agents or employees liable for any loss, cost or damage suffered due to your reliance upon EVA's advice. Where liability cannot be excluded or waived, you agree that our liability will (to the extent permitted by law) be limited to, at our election, the cost of providing the service provided by EVA to you, or the resupply of such a service.
          </p>
          <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
        </div>
        <div className="modal-footer" style={{ padding: "0px 20px 10px 20px" }}>
          <Button
            style={{
              backgroundColor: "#32325d",
              border: "1px solid #32325d",
              color: "#fff",
            }}
            data-dismiss="modal"
            onClick={closeDisclaimerModalHandler}
          >
            Close
          </Button>
        </div>
      </Modal>

    </>
  );
};

export default EvaToggleSwitch;
